import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=55353591&scoped=true"
import script from "./merge.vue?vue&type=script&lang=js"
export * from "./merge.vue?vue&type=script&lang=js"
import style0 from "./merge.vue?vue&type=style&index=0&id=55353591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55353591",
  null
  
)

export default component.exports